<template>
  <div>
    <redPacketForm />
    <redPacketDetail :idList="idList" />
    <!-- 红包记录 -->
    <redPacketRecord />
  </div>
</template>

<script>
import redPacketForm from "./redpacket";
import redPacketDetail from "./detail";
import redPacketRecord from "./record";
import Bus from "@/components/doc/bus";
export default {
  name: "redPacket",
  components: { redPacketForm, redPacketDetail, redPacketRecord },
  data() {
    return {
      idList: null,
       redPacketData:null
    };
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    Bus.$off("idList");
  },
  methods: {
    init() {
      Bus.$on("idList", (info) => {
        this.idList = info.id;
      });
    },
  },
};
</script>

<style>
</style>